export enum Loading {
    INITIAL = 'initial',
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error',
}